import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { ProjectModel, AdminProjectModel } from "../../models/ProjectModel";
import ProjectService from "../../services/ProjectService";
import ProjectSlice from "../slices/ProjectSlice";
import { RootState } from "../store";

import {
  setProjectSPIsBidDropped,
  setProjectSPBidPriority,
} from "./ProjectSPActions";
import {
  setProjectResponseIsBidDropped,
  setProjectResponseBidPriority,
} from "./ProjectResponseAction";

export const ProjectActions = ProjectSlice.actions;
export const fetchProjects = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch, getState) => {
    if (getState().project.all_Projects.length === 0) {
      const response: ProjectModel[] = await ProjectService.getAllProjects();
      dispatch(ProjectActions.setProjects(response));
    }
  };
};
export const fetchParticularProject = (
  Project_id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    const response: ProjectModel = await ProjectService.getParticularProject(
      Project_id
    );
    dispatch(ProjectActions.setParticularProject(response));
  };
};
//Basic Info
export const setProjectName = (
  projectName: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setProjectName(projectName));
  };
};

export const setProjecId = (
  projectId: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setProjectId(projectId));
  };
};

export const setUserId = (
  userId: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setUserId(userId));
  };
};

export const setCSGO = (
  id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setCSGO(id));
  };
};

export const setSBG = (
  id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setSBG(id));
  };
};

export const setSBU = (
  id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setSBU(id));
  };
};

export const setBUID = (
  buId: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setBUID(buId));
  };
};

export const setSegmentLOBID = (
  segmentLobid: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setSegmentLOBID(segmentLobid));
  };
};

export const setCustomerName = (
  customerNameId: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setCustomerName(customerNameId));
  };
};

export const setSegmentClassification = (
  segClass: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setSegmentClassification(segClass));
  };
};

export const setBaseLoad = (
  id: boolean
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setBaseLoad(id));
  };
};

export const setIsGreenCustomer = (
  id: boolean
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setIsGreenCustomer(id));
  };
};

// export const setCustomerTypeId = (customerTypeId: number | string): ThunkAction<void, RootState, unknown, AnyAction> => {
//     return (dispatch) => {
//         dispatch(ProjectActions.setCustomerTypeId(customerTypeId));
//     }
// }

export const setBriefScope = (
  briefScope: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setBriefScope(briefScope));
  };
};

export const setEstimatedValue = (
  text: number | string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setEstimatedValue(text));
  };
};

export const setContractType = (
  contractTypeId: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setContractType(contractTypeId));
  };
};

export const setPriceVariance = (
  priceVariance: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setPriceVariance(priceVariance));
  };
};

export const setAssessCustomerRating = (
  assessCustomerRating: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setAssessCustomerRating(assessCustomerRating));
  };
};

export const setOthersContactType = (
  othersContactType: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setOthersContactType(othersContactType));
  };
};

export const setCountryCorruptionRating = (
  text: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setCountryCorruptionRating(text));
  };
};
// Bid Details

export const setPreQualification = (
  text: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setPreQualification(text));
  };
};

export const setPreQualificationRating = (
  text: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setPreQualificationRating(text));
  };
};

export const setJVPartenerReq = (
  id: boolean
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setJVPartenerReq(id));
  };
};

export const setJVPartnerSuggestedName = (
  text: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setJVPartnerSuggestedName(text));
  };
};

export const setTechParterReq = (
  id: boolean
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setTechParterReq(id));
  };
};

export const setTechPartnerSuggestedName = (
  text: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setTechPartnerSuggestedName(text));
  };
};

export const setWinProbability = (
  text: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setWinProbability(text));
  };
};

export const setFundingSource = (
  id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setFundingSource(id));
  };
};

export const setOtherFundingSource = (
  otherFundingSource: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setOthersFundingSource(otherFundingSource));
  };
};

export const setTenderExpectedDate = (
  date: Date
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setTenderExpectedDate(date));
  };
};

export const setAwardExpectedDate = (
  date: Date
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setAwardExpectedDate(date));
  };
};

export const setProjectDuration = (
  num: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setProjectDuration(num));
  };
};

export const setEstimatedTimeToBid = (
  num: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setEstimatedTimeToBid(num));
  };
};

export const setOAndM = (
  id: boolean
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setOAndM(id));
  };
};

export const setOMDuration = (
  text: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setOMDuration(text));
  };
};

export const setTenderingBandwidth = (
  id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setTenderingBandwidth(id));
  };
};

// Other Details

export const setTenderMaturity = (
  text: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setTenderMaturity(text));
  };
};

export const setCountry = (
  text: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setCountry(text));
  };
};

export const setState = (
  text: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setState(text));
  };
};

export const setCity = (
  text: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setCity(text));
  };
};

export const setLocation = (
  text: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setLocation(text));
  };
};

export const setEnvironmentClearanceStatus = (
  text: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setEnvironmentClearanceStatus(text));
  };
};

export const setRowStatus = (
  text: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setRowStatus(text));
  };
};

export const setGeography = (
  id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setGeography(id));
  };
};

export const setCompetitionIntensity = (
  id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setCompetitionIntensity(id));
  };
};
export const setProposalStage = (
  text: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setProposalStage(text));
  };
};

export const setCompetitorsWithClient = (
  text: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setCompetitorsWithClient(text));
  };
};

export const setWinStrategyAndValueProposition = (
  text: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setWinStrategyAndValueProposition(text));
  };
};

export const setTimeToPQ = (
  text: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setTimeToPQ(text));
  };
};

export const setLicenseRequired = (
  id: boolean
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setLicenseRequired(id));
  };
};

export const setLicenseRequiredNotAvailable = (
  text: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setLicenseRequiredNotAvailable(text));
  };
};

export const setExpectedCompetitors = (
  text: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setExpectedCompetitors(text));
  };
};

export const setAnyOtherAdditionalInfo = (
  text: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setAnyOtherAdditionalInfo(text));
  };
};

// To set the project_Object with initial values on create bid
export const setProjectObjectWithInitialValues = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return (dispatch) => {
    dispatch(ProjectActions.setProjectObjectWithInitialValues());
  };
};

// To set the project_Object with initial values on create bid
export const setProjectObjectWithEditProject = (
  projectDetails: object
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setProjectObjectWithEditProject(projectDetails));
  };
};

// To view the project document in new tab
export const getProjectDocument = (
  id: number,
  type: string = "project"
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return () => {
    ProjectService.getProjectDocument(id, type);
  };
};

export const setIfProjectNameExists = (
  projectNameExists: boolean
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setIfProjectNameExists(projectNameExists));
  };
};

export const setGoFactorPercentage = (
  text: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setGoFactorPercentage(text));
  };
};

export const setGetFactorPercentage = (
  text: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setGetFactorPercentage(text));
  };
};

export const setManualGoFactorPercentage = (
  text: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setManualGoFactorPercentage(text));
  };
};

export const setManualGetFactorPercentage = (
  text: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setManualGetFactorPercentage(text));
  };
};

export const setManualGoGetFactorPercentage = (
  text: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setManualGoGetFactorPercentage(text));
  };
};

export const setManualGoGetFactorRemarks = (
  text: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setManualGoGetFactorRemarks(text));
  };
};

// To fetch all admin projects
export const fetchAdminProjects = () => {
  return async (dispatch: any) => {
    dispatch(ProjectActions.setIsAdminProjectsFetching(true));
    const response: AdminProjectModel[] =
      await ProjectService.getAllAdminProjects();
    dispatch(ProjectActions.setAdminProjects(response));
    dispatch(ProjectActions.setIsAdminProjectsFetching(false));
    return response;
  };
};

export const setValueSlab = (
  data: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setValueSlab(data));
  };
};

export const setIsNewProcessApplicable = (
  data: boolean
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setIsNewProcessApplicable(data));
  };
};

export const setPreBidExpenses = (
  data: number | string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setPreBidExpenses(data));
  };
};

export const setBidSubmissionDate = (
  date: Date
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setBidSubmissionDate(date));
  };
};

export const setOpportunityQualification = (
  data: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(ProjectActions.setOpportunityQualification(data));
  };
};

export const setIsBidDropped = (
  id: number,
  status: boolean
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(ProjectActions.setIsAdminProjectsFetching(true));
    await ProjectService.setIsBidDropped(id, status);
    dispatch(
      setProjectResponseIsBidDropped({
        id,
        status,
      })
    );
    dispatch(setProjectSPIsBidDropped(status));
    dispatch(ProjectActions.setIsAdminProjectsFetching(false));
    return;
  };
};

export const setBidPriority = (
  userId: number,
  id: number,
  priority: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(ProjectActions.setIsAdminProjectsFetching(true));
    await ProjectService.setBidPriority(userId, id, priority);
    dispatch(
      setProjectResponseBidPriority({
        id,
        priority,
      })
    );
    dispatch(setProjectSPBidPriority(priority));
    dispatch(ProjectActions.setIsAdminProjectsFetching(false));
    return;
  };
};
